import { FC, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { DeleteCollectionsModal } from "@/components/modal/delete-collections/delete-collections-modal";
import { CollectionsListPageList } from "@/pages/collections/components/CollectionsListPageList";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { FadeBottom } from "@/components/horizontal-scroll/FadeBottom";
import { ShareSheetModal } from "@/components/modal/share-sheet/share-sheet-modal";
import { MdsPanelContainer } from "@/design-system/components/panel";
import { TrackedEvent } from "@/domains/metrics";
import { trackEvent } from "@/domains/metrics";
import { useTabPageStore } from "@/hooks/useTabPageStore";
import { useTabParams } from "@/hooks/useTabParams";

interface Props {}

export const ImportedCollectionsListPage: FC<Props> = observer(() => {
  const { importBatchId } = useTabParams();
  const page = useTabPageStore("collectionsListPage");

  useEffectOnMount(() => {
    page.resetState();
  });

  /**
   * Track views of the collections list page.
   */
  useEffect(() => {
    trackEvent(TrackedEvent.ImportedCollectionsView, {
      lens: page.lens,
      sort_by: page.sortBy,
      import_batch_id: importBatchId,
    });
  }, [page.lens, page.sortBy, importBatchId]);

  return (
    <>
      <ShareSheetModal store={page.shareSheetModal} />
      <DeleteCollectionsModal state={page.deleteCollectionModal} />
      <MdsPanelContainer>
        {!page.isLoading && <CollectionsListPageList />}
        <FadeBottom />
      </MdsPanelContainer>
    </>
  );
});
